/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import React, { ReactNode, useState } from 'react';
import FilterListIcon from '@mui/icons-material/FilterList';
import { IconButton, Box, Popper, Paper, ClickAwayListener } from '@mui/material';
import GenericSearchableDropdown from './../Searchabledropdown/genericSearchableDropdown';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from 'redux/store';

type OptionType = {
    label: string;
    value: string;
};

type IconOnlyDropdownProps = {
    selectedType: string;
    handleSelectedType: (value: string) => void;
    dropdownMenuPrograms: OptionType[];
    [key: string]: any;
    icon?: ReactNode;
};

const IconOnlyDropdown = ({
    selectedType,
    handleSelectedType,
    dropdownMenuPrograms,
    icon,
    ...restProps
}: IconOnlyDropdownProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleIconClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();

    return (
        <Box>
            <IconButton
                onClick={handleIconClick}
                style={{
                    cursor: 'pointer',
                    backgroundColor:
                        selectedType && selectedType !== t('all', { lng: language })
                            ? '#dddddd'
                            : undefined,
                }}
            >
                {icon ? icon : <FilterListIcon />}
            </IconButton>

            <Popper
                open={open}
                anchorEl={anchorEl}
                placement="right-start"
                modifiers={[
                    { name: 'offset', options: { offset: [0, 8] } },
                    { name: 'flip', options: { fallbackPlacements: ['left-start'] } },
                ]}
                style={{ zIndex: 1500 }}
            >
                <ClickAwayListener onClickAway={handleClose}>
                    <Paper sx={{ p: 1, width: 250 }}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '100%',
                            }}
                        >
                            <GenericSearchableDropdown
                                selectedType={selectedType}
                                handleSelectedType={(value) => {
                                    handleSelectedType(value);
                                    handleClose();
                                }}
                                dropdownMenuPrograms={dropdownMenuPrograms}
                                {...restProps}
                                openOnMount={true}
                            />
                        </Box>
                    </Paper>
                </ClickAwayListener>
            </Popper>
        </Box>
    );
};

export default IconOnlyDropdown;
